var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.examineVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.examineVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { staticClass: "mt15", attrs: { "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                _vm._v(_vm._s(_vm.config.title) + "："),
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.config.type === 3
                          ? _vm.$t("customer.invoiced")
                          : _vm.$t("customer.passed")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.config.type === 3
                          ? _vm.$t("customer.notinvoiced")
                          : _vm.$t("customer.fail")
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.config.type === 3 && _vm.radio === 1
            ? [
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v("发票编号："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "text",
                        size: "small",
                        placeholder: "请输入发票编号",
                      },
                      model: {
                        value: _vm.num,
                        callback: function ($$v) {
                          _vm.num = $$v
                        },
                        expression: "num",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v("发送方式："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: _vm.$t("customer.placeholder54"),
                        },
                        on: { change: _vm.handleMethod },
                        model: {
                          value: _vm.invoice_type,
                          callback: function ($$v) {
                            _vm.invoice_type = $$v
                          },
                          expression: "invoice_type",
                        },
                      },
                      _vm._l(_vm.methodOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(
                        _vm._s(
                          _vm.invoice_type === "express"
                            ? "收货地址"
                            : "接收邮箱"
                        ) + "："
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "text",
                        size: "small",
                        placeholder:
                          _vm.invoice_type === "express"
                            ? "请输入收件地址"
                            : "请输入接受邮箱",
                      },
                      model: {
                        value: _vm.invoice_address,
                        callback: function ($$v) {
                          _vm.invoice_address = $$v
                        },
                        expression: "invoice_address",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm.radio === 2
                  ? _c("span", { staticClass: "color-tab" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.$t("public.remarks")) + "："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: 200,
                  "show-word-limit": "",
                  placeholder:
                    _vm.config.type === 3 && _vm.radio === 1
                      ? "用于快递单号/邮箱地址等相关开票信息"
                      : _vm.$t("customer.placeholder18"),
                },
                model: {
                  value: _vm.remarks,
                  callback: function ($$v) {
                    _vm.remarks = $$v
                  },
                  expression: "remarks",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.config.type === 3 && _vm.radio === 1
            ? _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v(_vm._s(_vm.$t("customer.billingdocuments")) + ":"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "examine-card" },
                  [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "el-upload-list el-upload-list--picture-card",
                      },
                      _vm._l(_vm.uploadList, function (item, index) {
                        return _c(
                          "li",
                          { key: index, staticClass: "el-upload-list__item" },
                          [
                            _vm.fileIsImage(item.type)
                              ? _c("i", {
                                  staticClass: "icon iconfont upload-icon",
                                  class: _vm.getFileType(2, item.name),
                                })
                              : _c("el-image", { attrs: { src: item.path } }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-actions" },
                              [
                                !_vm.fileIsImage(item.type)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-preview",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePictureCardPreview(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-zoom-in",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-delete",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleFileDelete(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: _vm.fileUrl,
                          "list-type": "picture-card",
                          "on-success": _vm.handleSuccess,
                          headers: _vm.myHeaders,
                          "show-file-list": false,
                          "before-upload": _vm.handleUpload,
                          data: _vm.uploadData,
                          multiple: "",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-plus",
                          attrs: { slot: "default" },
                          slot: "default",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isImage
                      ? _c("el-image-viewer", {
                          attrs: {
                            "on-close": _vm.closeImageViewer,
                            "url-list": _vm.srcList,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }